import React from "react";
import { Button, Column, Icon, Row, Sheet, Text } from "@amzn/meridian";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";
import { Question } from "src/data/types";

type ObjectInstanceModalProps = {
  open: boolean;
  objectType: string;
  questions: Question[];
  completedInstances: Array<{
    instanceNumber: number;
    evidenceUri: string;
  }>;
  onClose: () => void;
  onInspectInstance: (instanceNumber: number) => void;
};

const ObjectInstanceModal = ({
  open,
  objectType,
  questions,
  completedInstances,
  onClose,
  onInspectInstance,
}: ObjectInstanceModalProps) => {
  const displayName = objectType.charAt(0).toUpperCase() + objectType.slice(1);
  const nextInstanceNumber = completedInstances.length + 1;
  
  return (
    <Sheet
      className="object-instance-sheet"
      type="overlay"
      side="bottom"
      open={open}
      onClose={onClose}
    >
      <div style={{ borderRadius: "21px" }}>
        <Column spacing="400">
          <Row alignmentHorizontal="justify">
            <Text type="h400">Inspect {displayName}</Text>
            <Button onClick={onClose} type="icon">
              <Icon tokens={closeSmallTokens} />
            </Button>
          </Row>

          <Column spacing="200">
            <Text type="b300">Questions to inspect:</Text>
            <Column spacing="100" spacingInset="none 300">
              {questions.map((question) => (
                <Text key={question.questionId} type="b100">
                  • {question.questionText}
                </Text>
              ))}
            </Column>
          </Column>
          
          {completedInstances.length > 0 && (
            <Column spacing="200">
              <Text type="b300">Previous Instances:</Text>
              <Column spacing="100" spacingInset="none 300">
                {completedInstances.map((instance) => (
                  <Text key={instance.instanceNumber} type="b100" color="success">
                    ✓ Instance #{instance.instanceNumber} (completed)
                  </Text>
                ))}
              </Column>
            </Column>
          )}
          
          <Row
            alignmentHorizontal="justify"
            widths="fill"
            spacingInset="400 none none"
          >
            <Button onClick={onClose} type="tertiary">
              Cancel
            </Button>
            <Button
              onClick={() => onInspectInstance(nextInstanceNumber)}
              type="primary"
            >
              Inspect Instance #{nextInstanceNumber}
            </Button>
          </Row>
        </Column>
      </div>
    </Sheet>
  );
};

export default ObjectInstanceModal;
